import {ICON_TYPES} from '../constants';

export const FullScreenIcon = () => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.0003 16.7156H10.667V15.3823H14.0003C14.1771 15.3823 14.3467 15.3121 14.4717 15.1871C14.5967 15.062 14.667 14.8925 14.667 14.7157V11.3823H16.0003V14.7157C16.0003 15.2461 15.7896 15.7548 15.4145 16.1299C15.0395 16.5049 14.5308 16.7156 14.0003 16.7156Z'
        fill='#E35205'
      />
      <path
        d='M1.33333 6.04867H0V2.71533C0 2.1849 0.210714 1.67619 0.585786 1.30112C0.960859 0.926046 1.46957 0.715332 2 0.715332L5.33333 0.715332V2.04867H2C1.82319 2.04867 1.65362 2.1189 1.5286 2.24393C1.40357 2.36895 1.33333 2.53852 1.33333 2.71533V6.04867Z'
        fill='#E35205'
      />
      <path
        d='M5.33333 16.7156H2C1.46957 16.7156 0.960859 16.5049 0.585786 16.1299C0.210714 15.7548 0 15.2461 0 14.7157L0 11.3823H1.33333V14.7157C1.33333 14.8925 1.40357 15.062 1.5286 15.1871C1.65362 15.3121 1.82319 15.3823 2 15.3823H5.33333V16.7156Z'
        fill='#E35205'
      />
      <path
        d='M16.0003 6.04867H14.667V2.71533C14.667 2.53852 14.5967 2.36895 14.4717 2.24393C14.3467 2.1189 14.1771 2.04867 14.0003 2.04867H10.667V0.715332H14.0003C14.5308 0.715332 15.0395 0.926046 15.4145 1.30112C15.7896 1.67619 16.0003 2.1849 16.0003 2.71533V6.04867Z'
        fill='#E35205'
      />
    </svg>
  );
};

FullScreenIcon.iconType = ICON_TYPES.FULL_SCREEN_ICON;
